import { ArrowUpRight } from "lucide-react";

const panels = [
  {
    bg: "#121110",
    fg: "#EFEAE1",
    sub: "#EFEAE1",
    accent: "#A8512E",
    title: ["FOUNDER", "IT", "ACADEMY"],
    bullets: [
      ["Thousands of students", " made job-ready for IT careers"],
      ["Bridging the skills gap", " between education and work"],
      ["Corporate training", " for a growing professional India"],
    ],
    brand: "Training Basket",
    meta: "NOIDA / 2017 — NOW (9 YEARS)",
    href: "https://blog.trainingbasket.in/",
  },
  {
    bg: "#A8512E",
    fg: "#121110",
    sub: "#EFEAE1",
    accent: "#EFEAE1",
    title: ["CO-FOUNDER", "COWORKING", "SPACES"],
    bullets: [
      ["Built from the ground up", " in Noida's startup ecosystem"],
      ["Covered by YourStory", " at launch in 2021"],
      ["Shared office & incubation", " for independent builders"],
    ],
    brand: "CoWorkZen",
    meta: "NOIDA / 2021 — NOW (5 YEARS)",
    href: null,
  },
  {
    bg: "#E3DCCD",
    fg: "#121110",
    sub: "#4A453F",
    accent: "#A8512E",
    title: ["FOUNDER", "FOOD", "COURT"],
    bullets: [
      ["Franchise launch", " with The Burger Company"],
      ["Growing into N Square", " — a food enthusiast's paradise"],
      ["Prominent restaurants", " under one curated roof"],
    ],
    brand: "N Square Food Court",
    meta: "NOIDA / 2022 — BUILDING",
    href: null,
  },
  {
    bg: "#1E1A16",
    fg: "#EFEAE1",
    sub: "#EFEAE1",
    accent: "#A8512E",
    title: ["THE NEXT", "QUIET", "BET"],
    bullets: [
      ["Always listening", " for the next unique vertical"],
      ["Partnerships & mentorship", " with driven founders"],
      ["If it can be built better,", " I'm interested"],
    ],
    brand: "What's next?",
    meta: "EVERYWHERE / 2026 — ?",
    href: null,
  },
];

export const TrackRecord = () => (
  <section id="track-record" data-testid="track-record-section">
    {panels.map((p, i) => (
      <div
        key={p.brand}
        className="sticky top-0 min-h-screen flex flex-col justify-between px-5 lg:px-10 py-24 lg:py-28"
        style={{ backgroundColor: p.bg, color: p.fg }}
        data-cursor="view"
        data-testid={`track-panel-${i}`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start flex-1">
          <h3 className="font-giant leading-[0.88] text-[15vw] lg:text-[7.5vw]">
            {p.title.map((line, j) => (
              <span key={j} className="block">{line}</span>
            ))}
          </h3>
          <ul className="lg:pt-4 space-y-3 border-l-2 pl-6" style={{ borderColor: p.accent }}>
            {p.bullets.map(([bold, rest], j) => (
              <li key={j} className="text-base lg:text-lg" style={{ color: p.sub, opacity: 0.92 }}>
                · <strong style={{ color: p.fg }}>{bold}</strong>{rest}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-wrap items-end justify-between gap-6 mt-16">
          <span className="text-xs uppercase tracking-[0.25em] font-medium" style={{ color: p.sub, opacity: 0.8 }}>
            {p.meta}
          </span>
          {p.href ? (
            <a
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-swash text-5xl lg:text-7xl inline-flex items-center gap-3 link-ink"
              style={{ color: p.accent }}
              data-testid={`track-brand-link-${i}`}
            >
              {p.brand} <ArrowUpRight size={36} />
            </a>
          ) : (
            <span className="font-swash text-5xl lg:text-7xl" style={{ color: p.accent }}>
              {p.brand}
            </span>
          )}
        </div>
      </div>
    ))}
  </section>
);

export default TrackRecord;
